import Guard from '../../services/Middleware'

export default [

  {
    path: '/Financeiro/Configuracoes',
    name:'Configuracoes Financeiro',
    component: () => import('@/views/financeiro/configuracoes/indexConfig.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Financeiro/Caixa',
    name:'Fluxo de Caixa',
    component: () => import('@/views/financeiro/indexFluxoCaixa.vue'),
    beforeEnter: Guard.auth
  },
  
  {
    path: '/Conciliacao-Financeira',
    name:'Conciliacao Financeira',
    component: () => import('@/components/conciliacaoFinanceira.vue'),
    beforeEnter: Guard.auth
  },

  {
    path: '/Contas-a-Pagar',
    name:'Contas a Pagar',
    component: () => import('@/views/financeiro/indexContasPagar.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Contas-a-Pagar/Fornecedores',
    name:'Fornecedores',
    component: () => import('@/views/financeiro/indexFornecedores.vue'),
    beforeEnter: Guard.auth,
  },
    {
    path: '/Contas-a-Pagar/Adicionar',
    name:'Adicionar Conta',
    component: () => import('@/views/financeiro/contasApagar/addConta.vue'),
    beforeEnter: Guard.auth,
  },



  {
    path: '/Contas-a-Receber',
    name:'Contas a Receber',
    component: () => import('@/views/financeiro/indexContasReceber.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Contas-a-Receber/Adicionar',
    name:'Adicionar Conta a Receber',
    component: () => import('@/views/financeiro/contasReceber/addConta.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Contas-a-Receber/Adicionar/:id',
    name:'Editar Conta a Receber',
    component: () => import('@/views/financeiro/contasReceber/addConta.vue'),
    beforeEnter: Guard.auth,
    props: true,
  },
  {
    path: '/Contas-a-Receber/Clientes',
    name:'Clientes',
    component: () => import('@/views/financeiro/indexClientes.vue'),
    beforeEnter: Guard.auth,
  },

]